import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const statusBadgeDefaultVariants = {
  "positionType": "text",
  "color": "red",
  "visible": true
}
const statusBadgeCompoundVariants = []

const statusBadgeSlotNames = [
  [
    "root",
    "statusBadge__root"
  ]
]
const statusBadgeSlotFns = /* @__PURE__ */ statusBadgeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, statusBadgeDefaultVariants, getSlotCompoundVariant(statusBadgeCompoundVariants, slotName))])

const statusBadgeFn = memo((props = {}) => {
  return Object.fromEntries(statusBadgeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const statusBadgeVariantKeys = [
  "visible",
  "color",
  "positionType"
]
const getVariantProps = (variants) => ({ ...statusBadgeDefaultVariants, ...compact(variants) })

export const statusBadge = /* @__PURE__ */ Object.assign(statusBadgeFn, {
  __recipe__: false,
  __name__: 'statusBadge',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: statusBadgeVariantKeys,
  variantMap: {
  "visible": [
    "true",
    "false"
  ],
  "color": [
    "red",
    "green"
  ],
  "positionType": [
    "normal",
    "icon",
    "text"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, statusBadgeVariantKeys)
  },
  getVariantProps
})